<div style="background: var(--background);">
    <trent-dpc-home-carousel></trent-dpc-home-carousel>
<trent-dpc-home-best-seller></trent-dpc-home-best-seller>
<trent-dpc-home-blogs></trent-dpc-home-blogs>
</div>